/**
 * @generated SignedSource<<7a829677db61a5799902fc0e24f08bac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CorpTypeEnum = "CORPS" | "INDIS";
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type RefundStage = "Declare" | "PaymentComplete" | "RefundCompleteA" | "RefundCompleteB" | "RefundDetermine" | "RefundPreDetermine" | "Review" | "Unknown";
export type RefundStatus = "ApplyComplete" | "ApplyImpossible" | "ApplyPossible" | "Complete" | "Impossible" | "None" | "Possible" | "RefundFinish" | "RefundImpossible" | "Retry";
export type checkSearchStatusQuery$variables = {
  corpType: CorpTypeEnum;
};
export type checkSearchStatusQuery$data = {
  readonly checkSearchStatus: {
    readonly errors: {
      readonly code: ErrorType;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly progress: string | null | undefined;
    readonly refundInfo: {
      readonly businessInfo: {
        readonly hometaxBizName: string | null | undefined;
        readonly hometaxBizNo: string | null | undefined;
        readonly taxpayerName: string | null | undefined;
      } | null | undefined;
      readonly cenSnmcTxreAmt: number | null | undefined;
      readonly empIncrEtrpTxamtDdcAmt: number | null | undefined;
      readonly intgEmpTxamtDdcAmt: number | null | undefined;
      readonly reSearchRequestId: number | null | undefined;
      readonly refundAmount: string;
      readonly refundId: string;
      readonly refundStage: RefundStage | null | undefined;
      readonly refundStatus: RefundStatus;
      readonly sctyInfeeTxamtDdcAmt: number | null | undefined;
      readonly snmcSpcTxreAmt: number | null | undefined;
    } | null | undefined;
    readonly result: boolean;
    readonly tritxRefundInfo: {
      readonly businessInfo: {
        readonly hometaxBizName: string | null | undefined;
        readonly hometaxBizNo: string | null | undefined;
        readonly taxpayerName: string | null | undefined;
      } | null | undefined;
      readonly refundAmount: string;
      readonly refundId: string;
      readonly refundStage: RefundStage | null | undefined;
      readonly refundStatus: RefundStatus;
      readonly tritxReSearchRequestId: number | null | undefined;
    } | null | undefined;
  };
};
export type checkSearchStatusQuery = {
  response: checkSearchStatusQuery$data;
  variables: checkSearchStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "corpType"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "corpType",
    "variableName": "corpType"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "result",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Errors",
  "kind": "LinkedField",
  "name": "errors",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundStatus",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundStage",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundAmount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "snmcSpcTxreAmt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cenSnmcTxreAmt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "empIncrEtrpTxamtDdcAmt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "intgEmpTxamtDdcAmt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sctyInfeeTxamtDdcAmt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reSearchRequestId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "BusinessInfo",
  "kind": "LinkedField",
  "name": "businessInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hometaxBizName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hometaxBizNo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxpayerName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tritxReSearchRequestId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "checkSearchStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CheckSearchStatusOutput",
        "kind": "LinkedField",
        "name": "checkSearchStatus",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundHistoryType",
            "kind": "LinkedField",
            "name": "refundInfo",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundHistoryType",
            "kind": "LinkedField",
            "name": "tritxRefundInfo",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v16/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "checkSearchStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CheckSearchStatusOutput",
        "kind": "LinkedField",
        "name": "checkSearchStatus",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundHistoryType",
            "kind": "LinkedField",
            "name": "refundInfo",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v17/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundHistoryType",
            "kind": "LinkedField",
            "name": "tritxRefundInfo",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v16/*: any*/),
              (v15/*: any*/),
              (v17/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cf68450256af844013edaf652345572f",
    "id": null,
    "metadata": {},
    "name": "checkSearchStatusQuery",
    "operationKind": "query",
    "text": "query checkSearchStatusQuery(\n  $corpType: CorpTypeEnum!\n) {\n  checkSearchStatus(corpType: $corpType) {\n    result\n    progress\n    errors {\n      code\n      message\n    }\n    refundInfo {\n      refundId\n      refundStatus\n      refundStage\n      refundAmount\n      snmcSpcTxreAmt\n      cenSnmcTxreAmt\n      empIncrEtrpTxamtDdcAmt\n      intgEmpTxamtDdcAmt\n      sctyInfeeTxamtDdcAmt\n      reSearchRequestId\n      businessInfo {\n        hometaxBizName\n        hometaxBizNo\n        taxpayerName\n      }\n      id\n    }\n    tritxRefundInfo {\n      refundId\n      refundStatus\n      refundStage\n      refundAmount\n      tritxReSearchRequestId\n      businessInfo {\n        hometaxBizName\n        hometaxBizNo\n        taxpayerName\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba7d0eefc846d1b8816eb6d30b47b014";

export default node;
